export default __webpack_public_path__ + "static/media/download-icon.c33e389c.svg";